package org.example.site_web.content

val ideaContent = listOf(
    "Diagnostic et tests terrain",
    "Banc contrôle qualité",
    "Saisie rapide",
    "Exploiter les données",
    "Communiquer avec l’ERP",
    "Étude de faisabilité",
    "Démonstrateur",
    "POC",
    "Visualisation",
    "Accélération",
    "Environnement difficiles"
)